(function () {
    "use strict";

    // State Variables
    let postsLoadedCount = 0;
    let postsLoaded = [];
    let nextPageContent;

    // Initialize Infinite Scroll Observer
    const infiniteScrollObserver = new IntersectionObserver(handleIntersection, {
        rootMargin: "500px 0px",
        threshold: 0,
    });

    const markerInfiniteScrollObserver = new IntersectionObserver(handleMarkerIntersection, {
        rootMargin: "500px 0px",
        threshold: 0,
    });



    // Add the first post to the loaded list to prevent duplicates
    if (typeof window.kompasInfiniteScroll !== "undefined" && window.kompasInfiniteScroll.firstPost) {
        postsLoaded.push(parseInt(window.kompasInfiniteScroll.firstPost, 10));
    }

    // Observe unobserved content elements
    function observeContentElements() {
        const contentElements = document.querySelectorAll(
            ".section-content:not(.observed)"
        );

        contentElements.forEach((element) => {

            const observer = new IntersectionObserver(handleIntersection, {
                threshold: 0.14,
            });

            observer.observe(element);
            element.classList.add("observed");

            // Initialize view time if not set
            if (!element.dataset.totalViewTime) {
                element.dataset.totalViewTime = 0;
            }
        });
    }

    /**
     * Load the next post and append to the DOM
     */
    function loadNextPost() {
        if (nextPageContent) {
            const infiniteLoader = document.querySelector("#infinite-loader");
            if (infiniteLoader) {
                infiniteLoader.insertAdjacentHTML("beforebegin", nextPageContent);
                nextPageContent = false;
            }
        }

        const hiddenSections = document.querySelectorAll(
            ".section-content[style*='display:none'], .section-content[style*='display: none']"
        );
        if (hiddenSections.length > 0) {
            hiddenSections.forEach((section) => (section.style.display = "block"));
            // Trigger any additional integrations
            handleIntegrations();
        }
        getNextPost();
    }

    /**
     * Fetch the next post's content
     */
    function getNextPost(postId = false) {
        if (typeof window.kompasInfiniteScroll === "undefined") {
            console.error("window.kompasInfiniteScroll is not defined.");
            return;
        }

        let post = postId || window.kompasInfiniteScroll.posts.shift();
        if (!post || postsLoaded.includes(post)) {
            nextPageContent = false;
            return;
        }

        postsLoaded.push(post);
        postsLoadedCount++;

        fetch(window.kompasInfiniteScroll.ajax_url, {  // Only access if window.kompasInfiniteScroll is defined
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams({
                action: "infinite_loading",
                post,
                firstPost: window.kompasInfiniteScroll.firstPost,
            }),
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.result) {
                    nextPageContent = result.content;
                } else {
                    console.log("No more posts to load.");
                    nextPageContent = false;
                }

                if (window.dataLayerData && result.datalayer) {
                    window.dataLayerData[result.id] = result.datalayer;
                }
            })
            .catch((error) => console.error("Error loading post:", error));
    }

    /**
     * Handle additional integrations (e.g., banners, embeds)
     */
    function handleIntegrations() {
        if (typeof window.handleAceSlots !== "undefined") {
            window.handleAceSlots();
        }
        if (typeof window.handleViralizeSlots !== "undefined") {
            window.handleViralizeSlots();
        }
        if (typeof window.kompasInstagramObserve !== "undefined") {
            window.kompasInstagramObserve();
        }
    }

    /**
     * Handle focus and tracking for a given element
     * @param {HTMLElement} target - The element to track
     */
    function handleFocusAndTracking(target) {
        const dataTarget = target;
        const titleTarget = document.querySelector("title");
        window.visibleContent = target;

        if (
            !dataTarget ||
            !titleTarget.textContent ||
            titleTarget.textContent === dataTarget.dataset.title
        ) {
            return;
        }

        // Update browser history
        updateBrowserHistory(dataTarget);

        // Update the page title
        titleTarget.textContent = dataTarget.dataset.title;

        // Track visibility and events
        trackVisibility(target, dataTarget);
    }

    /**
     * Update browser history
     * @param {HTMLElement} dataTarget - Element with data attributes
     */
    function updateBrowserHistory(dataTarget) {
        // Get the current URL and its query parameters
        const currentUrl = new URL(window.location.href);
        const queryParams = currentUrl.search;

        // Create a new URL from the target URL
        let newUrl = dataTarget.dataset.url;

        // If there are query parameters in the current URL, append them to the new URL
        // but only if the new URL doesn't already have its own query parameters
        if (queryParams && !newUrl.includes('?')) {
            newUrl += queryParams;
        } else if (queryParams && newUrl.includes('?')) {
            // If the new URL already has query parameters, we need to merge them
            const newUrlObj = new URL(newUrl, window.location.origin);
            const currentParams = new URLSearchParams(queryParams);

            // Append current parameters that don't exist in the new URL
            currentParams.forEach((value, key) => {
                if (!newUrlObj.searchParams.has(key)) {
                    newUrlObj.searchParams.append(key, value);
                }
            });

            newUrl = newUrlObj.href;
        }

        window.history.replaceState(
            {state: null},
            dataTarget.dataset.title,
            newUrl
        );
    }

    /**
     * Track visibility and events
     * @param {HTMLElement} target - Element to track
     * @param {HTMLElement} dataTarget - Element with data attributes
     */
    function trackVisibility(target, dataTarget) {
        if (
            target.classList.contains("tracked") &&
            !target.classList.contains("infinite_loaded")
        )
            return;

        document
            .querySelectorAll(".section-content.tracked")
            .forEach((element) => element.classList.remove("tracked"));

        target.classList.add("tracked");

        if (window.dataLayer) {

            if (window.dataLayerData && window.dataLayerData[parseInt(dataTarget.dataset.id, 10)]) {
                window.dataLayer.push(window.dataLayerData[parseInt(dataTarget.dataset.id, 10)]);
            }

            window.dataLayer.push({
                event: "virtualPageView",
                virtualPagePath: dataTarget.dataset.url,
                virtualPageTitle: dataTarget.dataset.title,
                author: dataTarget.dataset.author,
                combinedAbbreviation: dataTarget.dataset.combinedabbreviation,
                lastModifiedDate: dataTarget.dataset.modifieddate,
            });


            // Comscore
            if (window.localStorage && self.crypto && window.COMSCORE) {
                let cs_fpid = window.localStorage.getItem('cs_fpid')
                if (!cs_fpid) {
                    // Check if randomUUID method exists
                    if (typeof self.crypto.randomUUID === 'function') {
                        cs_fpid = self.crypto.randomUUID();
                    } else {
                        // Fallback UUID generation using crypto.getRandomValues
                        cs_fpid = ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
                            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
                        );
                    }
                    window.localStorage.setItem('cs_fpid', cs_fpid);
                }
                (window.COMSCORE && window.COMSCORE.beacon({
                    c1: "2",
                    c2: "40221722",
                    ns_site: "total",
                    cs_fpid: cs_fpid,
                    nmo_01: "0",
                    nmo_02: "0",
                }));
            }

        }

        // social sharing correction
        const socialLinks = ['facebook', 'twitter', 'pinterest', 'whatsapp', 'mail'];

        socialLinks.forEach(social => {
            const element = document.querySelector(`#soc-${social}`);
            if (element && dataTarget.dataset[social] !== element.getAttribute('href')) {
                element.setAttribute('href', dataTarget.dataset[social]);
            }
        });


    }

    /**
     * Handle Intersection Observer events
     * @param {Array} entries - Observer entries
     */
    function handleIntersection(entries) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                if (entry.target.id === "infinite-loader") {
                    loadNextPost();
                    observeContentElements();
                } else if (entry.target.classList.contains("section-content")) {
                    handleFocusAndTracking(entry.target);
                }
            }
        });
    }


    function handleMarkerIntersection(entries) {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                if (entry.target.id === "infinite-top-marker") {
                    getNextPost();
                    markerInfiniteScrollObserver.unobserve(entry.target);
                    markerInfiniteScrollObserver.disconnect();
                }
            }
        });
    }


    function updateViewTimer(content) {
        // parse content.dataset.totalViewTime to int
        content.dataset.totalViewTime = parseInt(content.dataset.totalViewTime) + 1;

        // Handle GTM QV timer events
        if (window.dataLayer && (
            parseInt(content.dataset.totalViewTime) === 15
            || parseInt(content.dataset.totalViewTime) === 20
            || parseInt(content.dataset.totalViewTime) === 30
            || parseInt(content.dataset.totalViewTime) === 60
        )) {
            window.dataLayer.push({
                event: 'timer.qv',
                timerValue: parseInt(content.dataset.totalViewTime)
            });
        }

    }


    /**
     * Initialize the script on DOMContentLoaded
     */
    document.addEventListener("DOMContentLoaded", () => {
        // Initialize content observation and timers
        observeContentElements();

        const target = document.querySelector("#infinite-loader");
        const marker = document.querySelector("#infinite-top-marker");

        if (target) {
            markerInfiniteScrollObserver.observe(marker);
            infiniteScrollObserver.observe(target);
            // do NOT preload getNextPost() here! It will disturb page meta.
        }

        // Allows external tools (e.g. marketing scripts) to trigger loading of a specific post
        // into the infinite scroll flow for campaign or promo insertion.
        //
        // Example:
        // document.dispatchEvent(new CustomEvent('triggerNextLoad', {
        //   detail: { postid: 140030 }
        // }));
        document.addEventListener("triggerNextLoad", function (e) {
            if (e.detail && e.detail.postid) {
                getNextPost(e.detail.postid);
                observeContentElements();
            }
        });

        setInterval(() => {
            if (!document.hidden && window.visibleContent) {
                updateViewTimer(window.visibleContent);
            }
        }, 1000);
    });
})();
